const cards = [
  {
    title: '海量片库，每日上新',
    desc: '覆盖电影、电视剧、综艺、动漫、纪录片等全品类资源，每日实时同步最新片源，追剧不等待。',
    img: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20showing%20a%20rich%20video%20streaming%20catalog%20with%20colorful%20movie%20and%20TV%20show%20poster%20thumbnails%20arranged%20in%20a%20neat%20grid%2C%20warm%20ambient%20lighting%20on%20a%20clean%20wooden%20desk%20surface%2C%20cozy%20home%20entertainment%20setup%2C%20soft%20natural%20light%20from%20window%2C%20cinematic%20color%20grading%20with%20subtle%20warm%20tones&width=800&height=600&seq=card-1-91movie&orientation=landscape',
    alt: '91精品影视海量片库展示',
  },
  {
    title: '超清画质，沉浸体验',
    desc: '支持1080P至4K超高清播放，适配不同网络环境智能切换码率，流畅不卡顿，带来影院级视听享受。',
    img: 'https://readdy.ai/api/search-image?query=A%20large%20flat%20screen%20TV%20displaying%20a%20cinematic%204K%20movie%20scene%20with%20vivid%20colors%20and%20sharp%20details%20in%20a%20modern%20dark%20living%20room%2C%20ambient%20bias%20lighting%20behind%20the%20screen%2C%20comfortable%20sofa%20silhouette%2C%20premium%20home%20theater%20atmosphere%2C%20soft%20warm%20glow%2C%20editorial%20interior%20photography&width=800&height=600&seq=card-2-91movie&orientation=landscape',
    alt: '91精品影视超清画质体验',
  },
  {
    title: '极速下载，离线畅享',
    desc: '支持高速下载和多任务并行，WiFi环境智能预缓存，无网络也能随时观看已下载内容，通勤旅途不无聊。',
    img: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20a%20download%20progress%20interface%20for%20video%20content%20with%20multiple%20items%20in%20download%20queue%2C%20placed%20on%20a%20minimal%20desk%20with%20coffee%20cup%2C%20warm%20sunlight%20streaming%20through%20window%2C%20modern%20workspace%20aesthetic%2C%20clean%20composition%2C%20soft%20natural%20lighting%20with%20gentle%20shadows&width=800&height=600&seq=card-3-91movie&orientation=landscape',
    alt: '91精品影视极速下载功能',
  },
  {
    title: '多端适配，无缝切换',
    desc: '手机、平板、电脑全平台覆盖，观看记录云端同步，随时随地接续上次进度，一台设备开始另一台继续。',
    img: 'https://readdy.ai/api/search-image?query=Multiple%20devices%20including%20smartphone%20tablet%20and%20laptop%20arranged%20on%20a%20clean%20white%20desk%2C%20all%20screens%20showing%20the%20same%20video%20streaming%20interface%20in%20sync%2C%20modern%20tech%20lifestyle%20setup%2C%20bright%20and%20airy%20workspace%20with%20plants%2C%20soft%20natural%20daylight%2C%20clean%20minimalist%20aesthetic&width=800&height=600&seq=card-4-91movie&orientation=landscape',
    alt: '91精品影视多端同步',
  },
  {
    title: '安全可靠，官方认证',
    desc: '91精品影视官方正版APP，通过多重安全检测认证，不含恶意代码和捆绑软件，保障用户隐私和设备安全。',
    img: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20a%20security%20verification%20and%20certification%20interface%20with%20shield%20icons%20and%20green%20checkmarks%2C%20placed%20on%20a%20professional%20desk%20setting%2C%20warm%20golden%20hour%20lighting%2C%20modern%20office%20background%20with%20subtle%20depth%20of%20field%2C%20trustworthy%20and%20professional%20atmosphere&width=800&height=600&seq=card-5-91movie&orientation=landscape',
    alt: '91精品影视安全认证',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-white">
      <div className="mx-auto max-w-screen-2xl px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            为什么选择91精品影视
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            五大核心优势，打造极致看片体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.slice(0, 3).map((card, i) => (
            <div key={card.title} className="group bg-background-50 rounded-2xl overflow-hidden border border-secondary-100 transition-all hover:border-primary-200">
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={card.img}
                  alt={card.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">{card.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          {cards.slice(3).map((card, i) => (
            <div key={card.title} className="group bg-background-50 rounded-2xl overflow-hidden border border-secondary-100 transition-all hover:border-primary-200 flex flex-col md:flex-row">
              <div className="relative w-full md:w-48 h-40 md:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={card.img}
                  alt={card.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5 flex-1">
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">{card.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}